import api, { API_ORIGIN } from "../axios";

export const BACKEND_BASE_URL = API_ORIGIN;
export const COVER_ASPECT = 3; // width / height, keeps the crop landscape
export const COVER_MAX_WIDTH = 1920;
export const COVER_MAX_BYTES = 5 * 1024 * 1024;
const COVER_TYPES = ["image/jpeg", "image/png", "image/webp"];

// settings may be null (users without a settings row) and background_image may be null.
export const coverUrl = (settings) =>
  settings?.background_image
    ? `${BACKEND_BASE_URL}/covers/${settings.background_image}`
    : null;

// Returns an error message, or null when the file is acceptable.
export function validateCoverFile(file) {
  if (!file || !COVER_TYPES.includes(file.type)) {
    return "Please choose a JPG, PNG or WebP image";
  }
  if (file.size > COVER_MAX_BYTES) return "Image must be 5 MB or smaller";
  return null;
}

// No Content-Type set: axios drops it for FormData so the browser adds the multipart boundary.
export const uploadCover = (blob) => {
  const fd = new FormData();
  fd.append("background", blob, "cover.jpg");
  return api.post("/user/settings/background", fd);
};

export const removeCover = () => api.delete("/user/settings/background");

export const coverErrorMessage = (err) =>
  err?.response?.data?.errors?.background?.[0] ||
  err?.response?.data?.message ||
  (err?.response ? "Something went wrong" : "Network error, please try again");
